import classNames from 'classnames';
import React, { useCallback, useEffect, useMemo, useState } from 'react';

import { Typography } from '@sravni/react-design-system';

import { BANNERS_DATA } from '../../constants/promoCarousel';
import commonStyles from '../../styles/common.module.scss';
import { makeMainGEvent, pushEvent } from '../../utils/analytics';

import { BigBlock } from './components/Blocks/BigBlock';
import { SmallBlock } from './components/Blocks/SmallBlock';
import styles from './promo-block.module.scss';

const PromoBlock = React.memo<{ darkTheme: boolean }>(({ darkTheme }) => {
  const [originUrl, setOriginUrl] = useState<string>('');

  useEffect(() => {
    setOriginUrl(document.location.origin);
  }, []);

  const handleClick = useCallback(
    (url: string) => {
      const link = `${originUrl}${url}`;

      try {
        pushEvent(
          makeMainGEvent({
            eventCategory: 'Внутренняя реклама',
            eventAction: link,
            eventLabel: link,
            eventValue: undefined,
          }),
        );
      } catch (error) {
        console.error(error);
      }

      document.location.href = link;
    },
    [originUrl],
  );

  const blocks = useMemo(() => {
    return Object.values(BANNERS_DATA).map((item) => {
      const props = {
        item,
        handleClick,
        key: item.key,
        darkTheme,
      };

      if (item.isForm) {
        return <BigBlock {...props} />;
      }

      return <SmallBlock {...props} />;
    });
  }, [darkTheme, handleClick]);

  return (
    <div className={commonStyles.wrapper} suppressHydrationWarning>
      <div className={classNames(commonStyles.inner, styles.beforeHeader)}>
        <Typography.Heading level={3} as={'h1'}>
          Вы{'\u00A0'}выбираете, мы{'\u00A0'}помогаем сохранить деньги
        </Typography.Heading>
        <div className={styles.content}>{blocks}</div>
      </div>
    </div>
  );
});

export default PromoBlock;
